import { useChannels } from '@entities/channel'
import { EmptyPost, InfiniteCalendar, MobilePost, usePosts } from '@entities/post'
import { EDisplayPosts } from '@pages/scheduled-posts-page/ui/scheduled-posts-page'
import { dayjs } from '@shared/lib/dayjs/dayjs'
import type { DateInterval } from '@shared/types'
import { BottomNavMobile } from '@widgets/page-template/ui/bottom-nav-mobile'
import { PostingMobileHeader } from '@widgets/posting-mobile-header'
import { theme } from 'antd'
import { useCallback } from 'react'
import * as styles from './published-posts-page.mobile.module.scss'

const BOT_USERNAME = process.env.BOT_USERNAME || ''

export const PublishedPostsPage = () => {
    const {
        token: { colorBgContainer }
    } = theme.useToken()

    const { currentChannel } = useChannels()

    const {
        posts,
        postTypes,
        selectedPostTypes,
        actions: { setSelectedPostTypes, setDates }
    } = usePosts({
        state: 'published',
        display: EDisplayPosts.period,
        channelId: currentChannel?.id
    })

    const onIntervalChange = useCallback((interval: DateInterval) => setDates(interval), [setDates])

    return (
        <>
            <PostingMobileHeader
                title="Опубликованные"
                current="published"
                postTypes={postTypes}
                selectedPostTypes={selectedPostTypes}
                setSelectedPostTypes={setSelectedPostTypes}
            />

            <div
                style={{
                    position: 'relative',
                    background: colorBgContainer,
                    padding: '20px 16px 0 16px',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <InfiniteCalendar
                    renderItem={(day) => {
                        const filteredPosts = posts?.results.filter((p) =>
                            p.publishDate ? dayjs(p.publishDate).format('YYYY-MM-DD') === day.date : false
                        )

                        return filteredPosts && filteredPosts.length > 0 ? (
                            <div className={styles.postsSlot}>
                                {filteredPosts.map((p) => (
                                    <MobilePost post={p} key={p.id} />
                                ))}
                            </div>
                        ) : (
                            <EmptyPost title="Постов нет" />
                        )
                    }}
                    onIntervalChange={onIntervalChange}
                />
            </div>
            <BottomNavMobile />
        </>
    )
}
